<template>
	<div
		class="ruler-step"
		:class="{ '-mobile': isMobileWebApp }"
	>
		<div
			v-if="!isMobileWebApp && isMajor"
			class="ruler-step__label"
		>
			{{ valueLabel }}
		</div>
		<div
			class="ruler-step__indicator"
			:class="{ '-major': isMajor, '-medium': isMedium, '-minor': isMinor }"
		/>
	</div>
</template>

<script>
export default {
	name:  'RulerStep',
	props: {
		// type MAJOR | MEDIUM | MINOR
		type: {
			type:    String,
			default: 'MINOR',
		},
		// seconds
		value: {
			type:    Number,
			default: 0,
		},
		// label
		label: {
			type:    String,
			default: '',
		},
		isMobileWebApp: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		isMajor() {
			return this.type === 'MAJOR';
		},
		isMedium() {
			return this.type === 'MEDIUM';
		},
		isMinor() {
			return this.type === 'MINOR';
		},
		valueLabel() {
			if (this.label && this.label.length > 0) return this.label;
			return this.value;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import './timeline.scss';

.ruler-step {
	position: absolute;
	transform: translate(-50%, 0);
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	pointer-events: none;
}

.ruler-step__label {
	margin-bottom: 8px;
	max-width: none;
	font-size: 10px;
	font-weight: 600;
	color: $timeline-ruler-label-foreground;
}

.ruler-step__indicator {
	position: absolute;
	bottom: 0;
	width: 1px;

	&.-major {
		height: 8px;
		background: var(--color-grey-400);
	}

	&.-medium {
		height: 8px;
		background: var(--color-grey-700);
	}

	&.-minor {
		height: 6px;
		background: var(--color-grey-700);
	}

	.ruler-step.-mobile & {
		&.-major {
			background: var(--color-grey-600);
		}

		&.-medium,
		&.-minor {
			height: 4px;
			background: var(--color-grey-600);
		}
	}
}
</style>
